import React from 'react';
import Tag from '@components/tag';
import * as styles from './FirmConfirmation.scss';

const FirmConfirmation = ({
  firmTypeAbbreviation,
}) => (
  <Tag
    theme="blue"
    size="small"
    className={styles.firmConfirmation}
    translate="no"
  >
    {firmTypeAbbreviation}
  </Tag>
);

export default FirmConfirmation;
